import React, { useEffect, useState, type RefObject } from 'react';
import { Fab, useTheme, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export const LAYOUT_MAIN_SCROLL_ID = 'layout-main-scroll';
export const BACK_TO_TOP_SHOW_AFTER_PX = 320;

export const shouldShowBackToTop = (scrollTop: number): boolean =>
  Number(scrollTop) > BACK_TO_TOP_SHOW_AFTER_PX;

export const scrollElementToTop = (el: HTMLElement | null | undefined): void => {
  if (!el || typeof el.scrollTo !== 'function') return;
  el.scrollTo({ top: 0, behavior: 'smooth' });
};

export const BackToTopFab: React.FC<{ scrollRef: RefObject<HTMLElement | null> }> = ({
  scrollRef,
}) => {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return undefined;
    const onScroll = () => setVisible(shouldShowBackToTop(el.scrollTop));
    onScroll();
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [scrollRef]);

  return (
    <Zoom in={visible} unmountOnExit>
      <Fab
        size="medium"
        color="default"
        aria-label="Back to top"
        data-testid="back-to-top"
        onClick={() => scrollElementToTop(scrollRef.current)}
        sx={{
          position: 'fixed',
          right: 24,
          bottom: 96,
          zIndex: theme.zIndex.drawer + 2,
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
};
